function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ReformationTemplate = require('./reformation.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ReformationOverlay = /*#__PURE__*/function () {
  function ReformationOverlay(app, mod) {
    _classCallCheck(this, ReformationOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false);
  }
  return _createClass(ReformationOverlay, [{
    key: "hide",
    value: function hide() {
      this.overlay.hide();
    }
  }, {
    key: "render",
    value: function render() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.visible = true;
      var name = '';
      if (res) {
        name = res.name;
      }
      this.overlay.show(ReformationTemplate(name, res));
      this.overlay.setBackgroundColor('#000'); // black background

      //
      // pull over theses-overlay / zoom if visible
      //
      document.querySelectorAll('.theses-overlay').forEach(function (el) {
        var zindex = el.style.zIndex;
        var my_zindex = document.querySelector('.reformation-overlay');
        if (my_zindex) {
          if (parseInt(zindex) >= parseInt(my_zindex.style.zIndex)) {
            my_zindex.style.zIndex = parseInt(zindex) + 1;
          }
        }
      });
      if (res == null) {
        return;
      }
      for (var i = 0; i < res.pdice.length; i++) {
        var rrclass = '';
        if (res.protestants_win == 1) {
          if (res.pdice[i] >= res.p_high) {
            rrclass = 'hit';
          }
        }
        var html = "\n\t\t\t    <div class=\"reformation-row\">\n\t\t\t    \t<div class=\"reform-box-description\">".concat(res.p_roll_desc[i].name, " <div class=\"adjacency\">").concat(res.p_roll_desc[i].desc, "</div></div>\n\t\t            \t<div class=\"reform-roll ").concat(rrclass, "\">").concat(res.pdice[i], "</div>\n\t\t            </div>\t\n\t\t\t  ");
        this.app.browser.addElementToSelector(html, '.reformation-box .protestant');
      }
      for (var _i = 0; _i < res.cdice.length; _i++) {
        var _rrclass = '';
        if (res.protestants_win != 1) {
          if (res.cdice[_i] >= res.c_high) {
            _rrclass = 'hit';
          }
        }
        var _html = "\t  \n\t\t\t    <div class=\"reformation-row\">\n\t\t\t    \t<div class=\"reform-box-description\">".concat(res.c_roll_desc[_i].name, " <div class=\"adjacency\">").concat(res.c_roll_desc[_i].desc, "</div></div>\n\t\t            \t<div class=\"reform-roll ").concat(_rrclass, "\">").concat(res.cdice[_i], "</div>\n\t\t            </div>\n\t\t\t  ");
        this.app.browser.addElementToSelector(_html, '.reformation-box .papacy');
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }]);
}();
module.exports = ReformationOverlay;